var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDispatcherOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin-Flows",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit-Dispatcher",
    transform: "translate(-22.000000, -702.000000)",
    fill: "#FF5F00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 242.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_headset",
    transform: "translate(20.000000, 418.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,10 C18,7 15,4 12,4 C9,4 6,7 6,10 L6,16 L4,16 L2,15 L2,11 L4,10 C4,6 8,2 11.9911,2 C15.9822,2 20,6 20,10 L22,11 L22,15 L20,16 L18,16 L18,10 L18,10 Z M10,22 L10,20 L15,20 C16.4477153,20 18,18.4477153 18,17 L20,17 C20,19.5522847 17.5522847,22 15,22 L10,22 Z",
    id: "shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDispatcherOrange);
export default __webpack_public_path__ + "static/media/ico_dispatcher_orange.4d775358e179e8301bca0e391011f47e.svg";
export { ForwardRef as ReactComponent };